export const EditValidateFields = (values) => {
    let errors = {};

    if (!values.userName?.trim()) {
        errors.userName = "Name field is required.";
    } else if (values?.userName.length < 3 || values?.userName.length > 25) {
        errors.userName = "UserName must be between 3 and 25 characters.";
    }

    if (!values?.email) {
        errors.email = "Email field is required.";
    } else if (!/\S+@\S+\.\S+/.test(values?.email)) {
        errors.email = "Invalid email format. Please provide a valid email address.";
    }

    return errors

}